import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

interface DateTimeFieldProps extends PropsWithChildren {
  /** ID used to fetch localized text for the field's label */
  labelIntlId: string;
  /** ID of the element that the label in the component labels */
  labelFor: string;
}

function DateTimeField({
  labelIntlId,
  labelFor,
  children,
}: DateTimeFieldProps) {
  return (
    <Styled.DateTimeFieldWrapper>
      <Styled.DateTimeLabel htmlFor={labelFor}>
        <FormattedMessage id={labelIntlId} />
      </Styled.DateTimeLabel>
      {children}
    </Styled.DateTimeFieldWrapper>
  );
}

export default DateTimeField;
